// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grouped-type{position:relative}.rke-switch{margin-top:-10px;position:absolute;right:0}", ""]);
// Exports
module.exports = exports;
